module.exports = __webpack_public_path__ + "static/media/tao2.442c6164.png";